"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = output;

// returns a binder for output element
function output() {
  return {
    on: null,
    getValue: function getValue() {
      return this.value || this.textContent;
    },
    setValue: function setValue(value) {
      var property = 'form' in this ? 'value' : 'textContent';
      this[property] = value === null ? '' : "".concat(value);
    }
  };
}
//# sourceMappingURL=output.js.map